export const MODAL_MAX_WIDTH = 650
export const PAYMENT_TYPE = 'card'
export const PAYMENT_PROVIDER = 'square'

export const LPA_CASE_QUOTE_TYPE = {
  SINGLE: 'single',
  COUPLE: 'couple',
} as const
